import React from "react";
import {
  DndContext,
  closestCenter,
  DragEndEvent,
  SensorDescriptor,
  SensorOptions,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

interface SortableListProps {
  sensors: SensorDescriptor<SensorOptions>[];
  onDragEnd: (event: DragEndEvent) => void;
  ids: string[];
  children: React.ReactNode;
}

/**
 * Pure JSX wrapper around `<DndContext><SortableContext>...</SortableContext></DndContext>`
 * with the project-default `closestCenter` collision detection and vertical list
 * sorting strategy.
 */
export default function SortableList({
  sensors,
  onDragEnd,
  ids,
  children,
}: SortableListProps) {
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
    >
      <SortableContext
        items={ids}
        strategy={verticalListSortingStrategy}
      >
        {children}
      </SortableContext>
    </DndContext>
  );
}
